import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/terms/page.tsx");
